import { ResponsiveContainer, Tooltip, Treemap } from "recharts"
import { GroupSummary } from "models/opportunity-dashboard"
import { money } from "./format"

interface GroupTreemapChartProps {
    title: string
    data: GroupSummary[]
}

const PALETTE = [
    "var(--bs-primary)", "#1e2a8a", "#d97745", "#6a1b7a", "#d04f9b", "#7c5ac8", "#2a9d8f", "#e0a800",
]

// One tile per group, sized by number of opportunities, with the name and count inside.
const Tile = (props: any) => {
    const { x, y, width, height, index, count } = props
    // Recharts also calls this for nodes without a name (e.g. the root); draw only real tiles.
    if (typeof props.name !== "string" || width <= 0 || height <= 0) return null
    const name: string = props.name
    return <g>
        <rect x={x} y={y} width={width} height={height} fill={PALETTE[index % PALETTE.length]} stroke="var(--bs-body-bg)" strokeWidth={2} />
        {width > 60 && height > 24 && <text x={x + 6} y={y + 18} fill="#fff" fontSize={13}>
            {name.length * 7 > width - 12 ? `${name.slice(0, Math.max(3, Math.floor((width - 12) / 7) - 1))}…` : name}
        </text>}
        {width > 16 && height > 20 && <text x={x + 6} y={y + height - 6} fill="#fff" fontSize={12}>{count}</text>}
    </g>
}

const GroupTreemapChart = ({ title, data }: GroupTreemapChartProps) => (
    <div className="section-container">
        <h5 className="mb-3">{title}</h5>
        {data.length === 0
            ? <p className="text-muted mb-0">No opportunities.</p>
            : <div style={{ width: "100%", height: 300 }}>
                <ResponsiveContainer width="100%" height="100%">
                    <Treemap
                        data={[...data].sort((a, b) => b.count - a.count)}
                        dataKey="count"
                        nameKey="name"
                        isAnimationActive={false}
                        content={<Tile />}
                    >
                        <Tooltip formatter={(count: number, _: any, item: any) => [`${count} · ${money(item?.payload?.value)}`, "Opportunities"]} />
                    </Treemap>
                </ResponsiveContainer>
            </div>}
    </div>
)

export default GroupTreemapChart
